import { create } from 'zustand';

export type ChatMessage = {
  senderID: string;
  room: string;
  message: string;
};

interface ChatStore {
  messagesByRoom: Record<string, ChatMessage[]>;
  addMessage: (message: ChatMessage) => void;
}

export const useChatStore = create<ChatStore>()((set) => ({
  messagesByRoom: {},
  addMessage: (message) =>
    set((state) => {
      const room = message.room;
      const existing = state.messagesByRoom[room] || [];
      return {
        messagesByRoom: {
          ...state.messagesByRoom,
          [room]: [...existing, message],
        },
      };
    }),
}));
